import { FundComponent } from "./components/FundComponent";
import "promise-polyfill/src/polyfill";
import "../helper/linq";
import "../global.scss";
import { JSLRender, h } from "jsl-render";
import { JSLRoute } from "jsl-route";
import culture from "jsl-ui/lib/core/culture";
import { IndexComponent } from "./pages/IndexComponent";
import { TaxonComponent } from "./pages/TaxonComponent";
import { UploadComponent } from "./pages/upload/UploadComponent";
import { StatusComponent } from "./pages/StatusComponent";
import { CheckComponent } from "./pages/CheckComponent";
import { LoginComponent } from "./pages/login/LoginComponent";
import { UploadExcelComponent } from "./pages/UploadExcelComponent";
import { isInRole, refreshPendingCount } from "../helper/ajax";
import { DetailSearchComponent } from "./pages/detail-search/DetailSearchComponent";
import { ContactComponent } from "./pages/ContactComponent";

culture.set("de");

(window as any).$_h = h;

const render: JSLRender = new JSLRender(document.getElementById("main"), true);

const index = new IndexComponent();

const routes = {
    "": (params: string[]) => {
        render.render(index);
    },
    "login": (params: string[]) => {
        render.render(new LoginComponent(params.length > 0 ? decodeURIComponent(params[0]) : undefined));
    },
    "tax": (params: string[]) => {
        render.render(new TaxonComponent(parseInt(params[0], 10)));
    },
    "upload": (params: string[]) => {
        if (!(window as any)._user) {
            JSLRoute.navigate("#login/" + encodeURIComponent("upload"));
        }
        render.render(new UploadComponent(params[0]));
    },
    "detail": (params: string[]) => {
        render.render(new DetailSearchComponent());
    },
    "status": (params: string[]) => {
        render.render(new StatusComponent(parseInt(params[0], 10)));
    },
    "check": (params: string[]) => {
        render.render(new CheckComponent());
    },
    "contact": (params: string[]) => {
        render.render(new ContactComponent());
    },
    "excel": () => {
        if (!(window as any)._user) {
            JSLRoute.navigate("#login/" + encodeURIComponent("excel"));
        }
        render.render(new UploadExcelComponent());
    },
    "fund": (params: string[]) => {
        render.render(new FundComponent(parseInt(params[0], 10)));
    }
};

JSLRoute.setup(routes, (params) => {
    render.render({tag: "h1", attr: {style: "margin-top:8rem"}, content: "NOT found"});
});

JSLRoute.onNavigate((url) => {
    refreshPendingCount();
});
refreshPendingCount();


const experts = document.querySelectorAll(".role-expert");
if (isInRole("expert") || isInRole("admin")) {
    for (let i = 0; i < experts.length; i++) {
        (experts[i] as HTMLElement).classList.remove("role-expert");
    }
}

const admins = document.querySelectorAll(".role-admin");
if (isInRole("admin")) {
    for (let i = 0; i < admins.length; i++) {
        (admins[i] as HTMLElement).classList.remove("role-admin");
    }
}

//memory leak test

// let counter = 1000;

// function navUpload() {
//     JSLRoute.navigate("#upload");
//     counter--;
//     if (counter > 0) {
//         setTimeout(navTax, 500);
//     }
// }

// function navTax() {
//     JSLRoute.navigate("#status/1000012");
//     counter--;
//     if (counter > 0) {
//         setTimeout(navUpload, 500);
//     }
// }

// navUpload();
